module.exports = __webpack_public_path__ + "img/Slice5.a86ff270.png";